import $ from 'jquery';
import get from 'lodash/get';
import removeQueryParam from "../../helpers/remove-query-param";

export default function(){
    const openPreferences = get(window, 'rcProps.trigger.global.openPreferences', false);
    let checkCountryPref;
    function ifCountryPrefElExist() {
        var element = $('.js-view-country-preferences');

        if (element.length) {
            $('.js-view-country-preferences').trigger('click');
            clearInterval(checkCountryPref);
            removeQueryParam('preferences');
        }
    }

    if (openPreferences === true || openPreferences === 'true') {
        checkCountryPref = setInterval(ifCountryPrefElExist, 500);
        ifCountryPrefElExist();
    }

};



// WEBPACK FOOTER //
// ./src/scripts/entry-points/chrome/footer/amp-open-preferences.js